// extracted by mini-css-extract-plugin
export default {"container":"W_g","mainTitle":"W_fC","secondaryTitle":"W_fD","signUpButton":"W_fF"};